<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { PAGES_WITH_CLINIC_SELECTION } from '@/constants'
import { useClinicStore } from '@/stores'
import { PermissionTypeEnums } from '@/types'
import { Separator, SidebarTrigger } from '@/ui'

import ClinicCombobox from './ClinicCombobox.vue'
import GlobalSearch from './GlobalSearch.vue'
import HeaderBreadcrumbs from './HeaderBreadcrumbs.vue'

const route = useRoute()
const clinicsStore = useClinicStore()
const { permissions } = storeToRefs(clinicsStore)

const canSearchPatient = computed(() => permissions.value?.[PermissionTypeEnums.VIEW_PATIENTS])
</script>

<template>
  <header class="flex shrink-0 items-center justify-between gap-2 py-2 transition-[width,height] ease-linear">
    <div class="flex items-center gap-2 px-4">
      <SidebarTrigger class="-ml-1" />
      <Separator orientation="vertical" class="mr-2 h-4" />
      <HeaderBreadcrumbs />
    </div>
    <template v-if="PAGES_WITH_CLINIC_SELECTION.includes(route.path)">
      <ClinicCombobox />
    </template>
    <div class="flex items-center gap-2 px-4">
      <GlobalSearch v-if="canSearchPatient" />
    </div>
  </header>
</template>
